module.exports = __webpack_public_path__ + "static/media/google.09aea0f5.svg";